// extracted by css-extract-rspack-plugin
export default {"cls1":"AutoCompleteResults-cls1_KdN","cls2":"AutoCompleteResults-cls2_2US AutoCompleteResults-cls1_KdN"};